import { useEffect, useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { supabase } from '../lib/supabase';
import { useMyRestaurants } from '../hooks/useMyRestaurants';
import { useRole } from '../hooks/useRole';

export function DashboardPage() {
  const { t } = useTranslation();
  const { restaurants, loading } = useMyRestaurants();
  const { isMaster, loading: roleLoading } = useRole();
  const restaurant = restaurants[0];

  const [menuCount, setMenuCount] = useState<number | null>(null);
  const [tableCount, setTableCount] = useState<number | null>(null);

  useEffect(() => {
    if (!restaurant) return;
    void supabase
      .from('menu_items')
      .select('id', { count: 'exact', head: true })
      .eq('restaurant_id', restaurant.id)
      .then(({ count }) => setMenuCount(count ?? 0));
    void supabase
      .from('tables')
      .select('id', { count: 'exact', head: true })
      .eq('restaurant_id', restaurant.id)
      .then(({ count }) => setTableCount(count ?? 0));
  }, [restaurant]);

  if (loading || roleLoading) return <div className="center-note">{t('common.loading')}</div>;
  // Master sem restaurante próprio vai direto para a área administrativa
  if (!restaurant) return <Navigate to={isMaster ? '/app/master' : '/onboarding'} replace />;

  return (
    <div className="page">
      <h1 className="page__title">{restaurant.name}</h1>
      <p className="page__subtitle">{t('dashboard.welcome')}</p>

      <div className="stat-grid">
        <div className="stat">
          <span className="stat__label">{t('dashboard.your_role')}</span>
          <span className="stat__value">{t(`team.role_${restaurant.role}`)}</span>
        </div>
        <div className="stat">
          <span className="stat__label">{t('dashboard.menu_items')}</span>
          <span className="stat__value">{menuCount ?? '—'}</span>
        </div>
        <div className="stat">
          <span className="stat__label">{t('dashboard.tables')}</span>
          <span className="stat__value">{tableCount ?? '—'}</span>
        </div>
      </div>

      <p className="muted-note">{t('dashboard.menu_soon')}</p>

      <Link className="btn btn--ghost" to="/app/team">
        {t('dashboard.go_team')}
      </Link>
    </div>
  );
}
